export default (
  {
    search: {
      spellcheck: suggestion
    } = {}
  } = {}
) => ({
  suggestion
})
